import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AGENDA_MODULE_NAMESPACE, AGENDA_RECORD } from '../../store/agenda/agenda-types.store';
import { VIEW_WEEK } from '../../common/constants';
import { ActivityStatus, AppointmentTypes } from '../../common/enums';
import { IAppointment, IAppointmentListingViewModel, AppointmentListingViewModel } from '../../models/appointment';
import { isNullOrUndefined } from 'util';
import { USER_MODULE_NAMESPACE } from '../../store/user/user-types.store';
import { IUserDetails } from '../../models/user';
import {Moment} from "moment";
import * as moment from 'moment';
import {BLOCK_MODULE_NAMESPACE, BLOCK_RESET_BLOCKS} from "../../store/block";

const AgendaStore = namespace(AGENDA_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    // 'agenda-modal-content': async () => import('./components/agenda-modal/AgendaModal.vue'),
    'agenda-modal-vertical': async () => import('./components/agenda-modal-vertical/AgendaModalVertical.vue'),
    'agenda-calendar': async () => import('./components/agenda-calendar/AgendaCalendar.vue'),
    'agenda-sidebar-datepicker': async () => import('./components/agenda-sidebar-date-picker/AgendaSideBarDatePicket.vue'),
    'agenda-sidebar-condition': async () => import('./components/agenda-sidebar-condition/AgendaSideBarCondition.vue'),
  }
})
class AgendaContainer extends Vue {

  private _clearTimeout: any;
  private dtEvent: string | null;
  dtAgendaDialogVisible: boolean;
  dtViewMode: string;
  dtAgendaElement: any;
  dtCurrentDate: string;
  dtStartDate: Moment;
  dtValidateIsLoading: boolean;
  dtWithoutValidateIsLoading: boolean;
  constructor() {
    super();
    this.dtAgendaDialogVisible = false;
    this.dtEvent = null;
    this.dtValidateIsLoading = false;
    this.dtWithoutValidateIsLoading = false;
    this.dtAgendaElement = {};
    this.dtViewMode = VIEW_WEEK;
    this.dtCurrentDate = '';
    this.dtStartDate = moment().subtract(moment().day(), 'days').add(1, 'days')
  }
  @AgendaStore.Getter eventDotsForDatepicker: any[];
  @AgendaStore.Getter activityStatus: ActivityStatus;
  @AgendaStore.Getter appointment: IAppointment;
  @UserStore.Getter userInfo: IUserDetails;

  @AgendaStore.Action(AGENDA_RECORD)
  storeRecordAppointment: (type?: string) => Promise<any>;

  @BlockStore.Mutation(BLOCK_RESET_BLOCKS)
  storeResetBlocks: () => void;

  get isCreating(): boolean {
    return isNullOrUndefined(this.appointment.id);
  }
  get lblSetting() {
    return {
      ...require('@/locales/agenda').default,
      ...require('@/locales/button').default
    }
  }
  get visibilityConfigs() {
    return require('@/assets/json-resources/visibility-configs.json').agenda
  }
  get conditionVisible() {
    return this.visibilityConfigs.condition.includes(this.userInfo.type);
  }
  get loading(): boolean {
    return this.activityStatus === ActivityStatus.Loading;
  }
  get coCurrentDate(): string { return this.dtCurrentDate; }
  set coCurrentDate(value: string) { this.dtCurrentDate = value; }
  get coStartDate(): Moment { return this.dtStartDate; }
  set coStartDate(value: Moment) { this.dtStartDate = value; }
  get titleDateFormatted() {
    let date1 = moment(this.coStartDate)
    let date2 = moment(this.coStartDate)
    date2.add(7, 'days')
    if (this.dtViewMode === 'agendaWeek') {
      if (date1.month() === date2.month()) {
        return date1.format('MMMM YYYY')
      } else {
        return date1.format('MMMM') + ' - ' + date2.format('MMMM YYYY')
      }
    } else {
      return date2.format('MMMM YYYY')
    }
  }
  get coIsAppointment(): boolean {
    return this.appointment.type === AppointmentTypes.Appointment;
  }
  get createWithoutValidateButtonVisible(): boolean {
    return this.coIsAppointment && this.isCreating && this.$route.meta.create_draft_appointment;
  }

  get modalTitle(): string {
    if (!this.coIsAppointment && this.appointment.id > 0) {
      return this.lblSetting.agendaModalTitleEventModification
    }

    return this.lblSetting.agendaModalTitle
  }
  handleChangeDate(type: string | 'next' | 'prev' | 'today') {
    this.dtAgendaElement.fullCalendar(type);
  }

  handleChangeView() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      this.dtAgendaElement.fullCalendar('changeView', this.dtViewMode)
    }, 100);
  }

  getActivedClass(viewMode): string {
    return this.dtViewMode === viewMode ? 'switch-mode--active' : 'switch-mode--normal'
  }

  handleCalendarEventClick({ calEvent, jsEvent, view }) {
  }
  handleCalendarSelect(appointment) {
    /* if (appointment.id > 0 && appointment.type === AppointmentTypes.Appointment && appointment.actions.length === 0) {
      alert('Invalid appointment, it does not have ticket ID');
      console.error(appointment, 'appointment')
      return;
    } */
    setTimeout(() => {
      this.dtEvent = appointment.event;
      this.dtAgendaDialogVisible = appointment !== undefined || appointment !== null;
    }, 300);
  }

  handleChangeDatePicker(date) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtAgendaElement.fullCalendar('gotoDate', date);
    }, 300);
  }

  handleSave(event) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtValidateIsLoading = true;
      this._handleSave();
    }, 300);
  }

  handleSaveWithoutValidate(event: string) {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      const modal: any = this.$refs['modal'];
      if (modal.$refs.form.validate()) {
        this.dtWithoutValidateIsLoading = true;
        this._handleSave('draft');
      }
    }, 300);

  }

  _handleSave(state?: string) {
    this.storeRecordAppointment(state)
      .then((payload: {
        appointment: IAppointmentListingViewModel,
        isUpdate: boolean
      }) => {
        if (state === 'draft') {
          this.dtWithoutValidateIsLoading = false;
        } else {
          this.dtValidateIsLoading = false;
        }
        this.dtAgendaDialogVisible = false;

        if (payload.isUpdate) {
          this.dtAgendaElement.fullCalendar('removeEvents', [this.dtEvent['_id']])
          this.dtAgendaElement.fullCalendar('renderEvent', payload.appointment, true);
        }
        else {
          setTimeout(() => {
            this.dtAgendaElement.fullCalendar('renderEvent', payload.appointment, true);
          }, 100);
        }
      })
      .then(() => this.dtEvent = null)
      .catch(error => {
        this.dtEvent = null;
        if (state === 'draft') {
          this.dtWithoutValidateIsLoading = false;
        } else {
          this.dtValidateIsLoading = false;
        }
        this.dtAgendaDialogVisible = false;
        throw error;
      })
  }

  beforeDestroy() {
    const elements = document.querySelectorAll('.calendar-menu-popover')
    for (let i = 0; i < elements.length; i++) {
      this.$nextTick(() => {
        if (elements[i].parentNode) {
          elements[i].parentNode.removeChild(elements[i])
        }
      })
    }
    this.storeResetBlocks()
  }
}

export default AgendaContainer;



// WEBPACK FOOTER //
// ./src/containers/agenda/index.ts